import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {ConfiguracionSalesforce} from '../interfaces/configuracion-sales-force';

@Injectable({
  providedIn: 'root'
})
export class ObtenerConfiguracionSalesForceService {

  public readonly publicasUrl: string;
  public configuracionSalesForce!: ConfiguracionSalesforce;

  private httpClient: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.httpClient = new HttpClient(httpHandler);
    this.publicasUrl = environment.apiUrl + '/guest/configuracion-cliente/sales-force';
  }

  public __invoke(): Promise<ConfiguracionSalesforce> {
    return new Promise<ConfiguracionSalesforce>((resolve, reject) => {
      this.httpClient.get<ConfiguracionSalesforce>(this.publicasUrl).subscribe({
        next: (configuracionSalesforce: ConfiguracionSalesforce) => {
          this.configuracionSalesForce = configuracionSalesforce;
          resolve(configuracionSalesforce);
        }, error: (errorResponse) => {
          reject(errorResponse);
        }
      });
    });
  }
}
